// extracted by mini-css-extract-plugin
export default {"wrap":"DataTable_wrap__A+vax","table":"DataTable_table__QoGGJ","sticky":"DataTable_sticky__aUGDM","hoverable":"DataTable_hoverable__gW4Xs"};